import React from "react";
import { Button } from "@lemonadetraining/web-ui";
import { CARD_UPDATE_TRY_AGAIN } from "./dunningCopy";

interface CardUpdateErrorProps {
  message: string;
  onRetry: () => void;
  busy: boolean;
}

/** The server's refusal, verbatim, beside a way to go again. Never a dead end. */
const CardUpdateError: React.FC<CardUpdateErrorProps> = ({ message, onRetry, busy }) => (
  <p role="alert" className="flex flex-wrap items-center gap-2 text-sm text-destructive">
    <span data-testid="card-update-error">{message}</span>
    <Button
      type="button"
      variant="link"
      className="h-auto min-h-[44px] p-0 text-sm"
      onClick={onRetry}
      disabled={busy}
      data-testid="card-update-retry"
    >
      {CARD_UPDATE_TRY_AGAIN}
    </Button>
  </p>
);

export default CardUpdateError;
